<lib-custom-date-picker-control
  #datePickerControl
  [formControl]="control"
  [placeholder]="'YYYY-MM-DD'"
  [widthPx]="cellWidth"
  [heightPx]="cellHeight"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [autoOpen]="true"
  [compact]="true"
  (dateSelected)="onDateSelected()"
></lib-custom-date-picker-control>
